module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/8-a2da75099d77573240e7537a2836bc8d.png";